// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const createOtherCredit = () => ({
    type: actions.CREATE_CLAIM_NORMAL_OTHER_CREDIT
});

export const changeDescription = (index, description, descriptionCollection) => ({
    data: findMatchingKey(description, descriptionCollection),
    index,
    property: 'details',
    type: actions.UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DESCRIPTION
});

export const changeAmount = (index, amount) => ({
    data: amount,
    index,
    property: 'amount',
    type: actions.UPDATE_CLAIM_NORMAL_OTHER_CREDIT_AMOUNT
});

export const changeDistance = (index, distance) => ({
    data: distance,
    index,
    property: 'distance',
    type: actions.UPDATE_CLAIM_NORMAL_OTHER_CREDIT_DISTANCE
});

export const changeComments = (index, comments) => ({
    data: comments,
    index,
    property: 'comments',
    type: actions.UPDATE_CLAIM_NORMAL_OTHER_CREDIT_COMMENTS
});

export const deleteOtherCredit = index => ({
    index,
    type: actions.DELETE_CLAIM_NORMAL_OTHER_CREDIT
});



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/other-credits.js